import { scrollbarTheme } from 'components/Scrollbar/theme';
import { baseThemeValues } from 'constants/common';

export const columnsFilterTheme = {
  activeSettingButton: {
    bg: 'palette.tertiary.5',
    text: 'palette.primary.40',
  },
  popover: {
    bg: 'palette.surface.3',
    borderColor: 'palette.transparent',
    borderRadius: '12px',
    borderWidth: '0px',
    boxShadow: 'palette.black:0.5',
    columnsTitle: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '12px',
      fontWeight: 600,
      text: 'palette.tertiary.95',
    },
    enableAllSwitch: {
      label: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 500,
        text: 'palette.tertiary.60',
      },
    },
    settingsColumn: {
      borderColor: 'palette.tertiary.10',
      borderWidth: '1px',
      pinDropZone: {
        base: {
          bg: 'palette.transparent',
          borderColor: 'palette.transparent',
          borderRadius: '8px',
          borderWidth: '2px',
        },
        over: {
          bg: 'palette.primary.20:0.1',
          borderColor: 'palette.primary.20',
          borderRadius: '8px',
          borderWidth: '2px',
        },
        pinText: {
          fontFamily: baseThemeValues.inherit,
          fontSize: '14px',
          fontWeight: 400,
          text: 'palette.tertiary.50',
        },
      },
      scrollbar: {
        ...scrollbarTheme,
        borderColor: 'palette.transparent',
        borderRadius: '10px',
        borderWidth: '4px',
        width: '10px',
      },
      shadowColor: 'palette.surface.3',
      stretchButton: {
        base: {
          text: 'palette.tertiary.80',
        },
        hover: {
          text: 'palette.tertiary.20',
        },
      },
    },
    title: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '18px',
      fontWeight: 700,
      text: 'palette.tertiary.95',
    },

    settingItem: {
      bg: 'palette.surface.5',
      borderColor: 'palette.transparent',
      borderRadius: '8px',
      borderWidth: '0px',
      dragArea: {
        active: {
          bg: 'palette.primary.20:0.1',
          borderColor: 'palette.primary.20',
          borderRadius: '8px',
          borderWidth: '2px',
        },
        base: {
          borderColor: 'palette.transparent',
          borderRadius: '8px',
          borderWidth: '2px',
        },
      },
      dragController: {
        bg: 'palette.surface.5',
        borderColor: 'palette.surface.4',
        borderWidth: '1px',
        icon: 'palette.tertiary.80',
      },
      fixedDragController: {
        base: {
          bg: 'palette.primary.20',
        },
        hover: {
          bg: 'palette.primary.10',
        },
      },
      fontFamily: baseThemeValues.inherit,
      fontSize: '14px',
      fontWeight: 400,
      text: 'palette.tertiary.95',
    },

    dragIcon: {
      arrow: 'palette.primary.20',
      dragDots: 'palette.tertiary.40',
      dragItemBody: 'palette.tertiary.10',
      dragItemBorder: 'palette.tertiary.10',
      dragItemZone: 'palette.tertiary.20',
      dragTextZone: 'palette.tertiary.20',
      switch: 'palette.primary.50',
      switchDot: 'palette.primary.90',
    },

    visibilityHandler: {
      bg: 'palette.transparent',
      borderColor: 'palette.surface.5',
      borderRadius: '6px',
      borderWidth: '1px',
      button: {
        base: {
          bg: 'palette.transparent',
          fontFamily: baseThemeValues.inherit,
          fontSize: '12px',
          fontWeight: 400,
          text: 'palette.tertiary.40',
        },
        hover: {
          bg: 'palette.surface.5',
          fontFamily: baseThemeValues.inherit,
          fontSize: '12px',
          fontWeight: 400,
          text: 'palette.tertiary.100',
        },
        selected: {
          bg: 'palette.primary.20',
          fontFamily: baseThemeValues.inherit,
          fontSize: '12px',
          fontWeight: 400,
          text: 'palette.primary.99',
        },
      },
      divider: 'palette.tertiary.10',
    },
  },
};
